import { PilotReleasedData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const PILOT_RELEASED_DATA_TAG = 'PilotReleasedData';
export default class PilotReleasedParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.PILOT_RELEASED, FIXED_PROTOCOL_CONTENT_TYPE_IDS.PILOT_RELEASED, PILOT_RELEASED_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            name: 'name',
            freeText: 'freeText',
            ladPos: 'ladderPosition',
            relea: 'released',
        };
    }
    createData(props, record) {
        const data = new PilotReleasedData(props.name, props.ladderPosition, props.released, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.name,
            };
            data.name = link;
        }
        return data;
    }
}
//# sourceMappingURL=PilotReleasedParser.js.map